

import axios from "axios";

const api = axios.create({
  baseURL: "https://dev.nuvvygroup.com/api",
  params: { api_password: "AI_Pos_passCode2026" },
  headers: { Accept: "application/json" },
});



api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const userType = localStorage.getItem("userType");

      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("userType");

      if (userType === "admin") {
        window.location.href = "/background/gate/login";
      } else {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
